A list of pay types that specify the method and interval of a payment.

These may be presented to a hirer for selection in a job posting flow.
A dropdown or radio group is recommended.

This query accepts browser tokens that include the `query:ontologies` scope.
